import { piniaOfficeOffer } from '@stores/useOfficeOfferStore';
import { createApp } from 'vue';
import CombinatorChoose from '@pages/offer-page/combinator/CombinatorChoose.vue';

export const combinator = () => {
  const app = createApp(CombinatorChoose);

  app.use(piniaOfficeOffer);
  app.mount('#combinator-choose-app');
};
